import React from "react";
import TimeRegistrationDayTag from "./TimeRegistrationDayTag";
import TimeRegistrationAddTimeButton from "./TimeRegistrationAddTimeButton";
import "./TimeRegistrationDayCardTopBar.scss";

/**
 * Cabecera móvil Mis fichajes: grid (día · horas+[+] · interruptor a la derecha).
 * El (+) va junto a los HH:mm; el menú de acciones va en la zona inferior de la card.
 */
const TimeRegistrationDayCardTopBar = ({
	time,
	dayType,
	disabled,
	isMain,
	renderTimeInputs,
	showAddButton,
	onAddTime,
	renderApprovalControl,
}) => (
	<div className="time-registration-day-card-top-bar">
		<div className="time-registration-day-card-top-bar__cell time-registration-day-card-top-bar__cell--day">
			<TimeRegistrationDayTag time={time.day} dayType={dayType} />
		</div>

		<div className="time-registration-day-card-top-bar__cell time-registration-day-card-top-bar__cell--inputs">
			{renderTimeInputs(time, disabled)}
			{showAddButton ? (
				<TimeRegistrationAddTimeButton
					onClick={(e) => onAddTime(e, time.day)}
					disabled={disabled}
				/>
			) : null}
		</div>

		<div className="time-registration-day-card-top-bar__cell time-registration-day-card-top-bar__cell--right">
			{isMain ? renderApprovalControl(time) : null}
		</div>
	</div>
);

export default TimeRegistrationDayCardTopBar;
